export default "__VITE_ASSET__CSoV9w_K__"